import { Callout, DefaultButton, FontIcon, getTheme, mergeStyleSets } from "@fluentui/react";
import React, { useState } from "react";

const getClassNames = (theme) =>
  mergeStyleSets({
    btnContainer: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: theme.spacing.s1,
      marginBottom: theme.spacing.s1,
      fontSize: 13,
      border: "2px solid #848099a3",
      cursor: "pointer",
      selectors: {
        "&:hover": {
          backgroundColor: theme.palette.buttonHover,
        },
      },
    },
    menuBtn: {
      display: "flex",
      justifyContent: "center",
      height: "auto",
      width: 16,
      borderRadius: "50%",
      padding: theme.spacing.s1,
      selectors: {
        "&:hover": {
          backgroundColor: theme.palette.buttonHover,
        },
      },
      menuIcon: {
        fontSize: 16,
        padding: theme.spacing.s2,
      },
    },
  });

const calloutStyles = {
  calloutMain: { display: "flex", flexDirection: "column" },
};

const buttonStyles = {
  root: { border: "none" },
  textContainer: { display: "flex", justifyContent: "start" },
};

const SnippetsMenuButton = ({
  snippet,
  onInsert,
  onDelete,
  onUpdate,
  onPreview,
  itemKey,
  caseAccountId = null,
  isGlobal = false,
  canManageGlobal = false,
}) => {
  let theme = getTheme();
  let { btnContainer, insertButton, menuBtn, menuIcon } = getClassNames(theme);
  const [isSideMenuOpen, setIsSideMenuOpen] = useState(false);

  const handleMenuClick = (e) => {
    e.stopPropagation();
    setIsSideMenuOpen(true);
  };

  const manageButtons = () => (
    <>
      <DefaultButton
        styles={buttonStyles}
        onClick={() => {
          setIsSideMenuOpen(false);
          return onUpdate(false, snippet);
        }}
      >
        Update to match selection
      </DefaultButton>
      <DefaultButton styles={buttonStyles} onClick={() => onDelete(snippet)}>
        Delete
      </DefaultButton>
    </>
  );

  const displayManageButtons = () => {
    if (!isGlobal && !caseAccountId) return manageButtons();
    else if (isGlobal && canManageGlobal) return manageButtons();
    else if (caseAccountId === snippet?.accountId) return manageButtons();
    else {
      return;
    }
  };

  return (
    <React.Fragment key={itemKey}>
      <div className={btnContainer} onClick={() => onInsert(snippet.content)}>
        <div className={insertButton}>{snippet.text}</div>
        <div className={menuBtn} onClick={handleMenuClick} id={`side-menu-btn-${snippet?.key}`}>
          <FontIcon className={menuIcon} aria-label="Menu" iconName="MoreVertical" />
        </div>
      </div>
      {isSideMenuOpen && (
        <Callout
          role="dialog"
          onDismiss={() => setIsSideMenuOpen(false)}
          target={`#side-menu-btn-${snippet.key}`}
          isBeakVisible={false}
          setInitialFocus
          coverTarget
          styles={calloutStyles}
        >
          <DefaultButton styles={buttonStyles} onClick={() => onPreview(snippet)}>
            Preview
          </DefaultButton>

          {displayManageButtons()}
        </Callout>
      )}
    </React.Fragment>
  );
};

export default SnippetsMenuButton;
